<div *ngIf="reason" class="w-100 flex justify-center mt-20 px-5 sm:px-0">
  <div
    class="w-100 sm:w-2/3 xl:w-1/2 flex text-center flex-col justify-center items-center"
  >
    <h1 *ngIf="reason === 'no_capacity_in_region'" class="text-white">
      Oh no, we're currently at capacity in your region :(
    </h1>
    <h1 *ngIf="reason === 'unavailable_in_region'" class="text-white">
      Oh no, we're not available yet in your region :(
    </h1>
    <p *ngIf="reason === 'no_capacity_in_region'">
      You can leave your email to get notified once we have capacity available
      in your region again.
    </p>
    <p *ngIf="reason === 'unavailable_in_region'">
      You can leave your email to get notified once CloudDeck is available in
      your region.
    </p>
    <form class="w-full sm:w-2/3 xl:w-1/2" [formGroup]="notifyForm" novalidate>
      <div class="mt-10">
        <input
          type="email"
          formControlName="email"
          class="input-dark text-center"
          placeholder="Your email address"
          [ngClass]="{
            'input-error': email.invalid && (email.dirty || email.touched)
          }"
        />
        <div *ngIf="email.invalid && (email.dirty || email.touched)">
          <p
            *ngIf="email.errors?.['required']"
            class="mt-2 text-sm text-red-600 dark:text-red-500"
          >
            Please provide your email address.
          </p>
          <p
            *ngIf="email.errors?.['email']"
            class="mt-2 text-sm text-red-600 dark:text-red-500"
          >
            Please provide a valid email address.
          </p>
        </div>
      </div>
    </form>
    <button
      class="btn-primary flex items-center mt-7 mb-10 plausible-event-name=CreatedReservation"
      (click)="createReservation()"
      [disabled]="busy || submitted"
    >
      <i-lucide
        *ngIf="!submitted && !busy"
        class="mr-1"
        name="bell"
      ></i-lucide>
      <i-lucide
        *ngIf="submitted && !busy"
        class="mr-1"
        name="check"
      ></i-lucide>
      <app-spinner *ngIf="busy" class="mr-2 -mb-1"></app-spinner>
      <span *ngIf="!submitted">Notify me</span>
      <span *ngIf="submitted">You will be notified</span>
    </button>
    <p *ngIf="error" class="mt-5 text-red-500">
      Something went wrong, please try again in a bit.
    </p>
    <p class="mt-10">
      <a href="https://discord.gg/pbBSQsF7Uz" target="_blank"
        >Join our Discord server</a
      >
      or
      <a href="https://twitter.com/clouddeckapp" target="_blank"
        >follow us on X</a
      >
      for the latest updates.
    </p>
  </div>
</div>
